<template>
  <footer v-if="$route.meta.showNavBar" class="fixed bottom-0 right-0 p-3 text-sm text-gray-600 dark:text-gray-400">
    © FoxSolution SRL
  </footer>
</template>

<script>
import { defineComponent, computed } from 'vue';
import { useRoute } from 'vue-router';

export default defineComponent({
  name: 'FooterComponent',
  setup() {
    const route = useRoute();
    return { route };
  }
});
</script> 